<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="modalContent" v-on:click="showPrizeMore = null">
        <h4>Image Gallery</h4>
        <div class="formCnt">
          <div class="fieldGroup">
            <label>Images</label>
            <div class="priceOk">
              <div class="priceNav p" v-if="prizeIdx > 0"
                v-on:click="prizeIdx -= 1"></div>
              <div class="priceNav n" v-if="d.media.length > 3 && prizeIdx < d.media.length - 3"
                v-on:click="prizeIdx += 1"></div>
              <div class="priceSc">
                <div class="prizeCnt" :style="{width: `${(d.media.length + 1) * 130}px`}"
                  :class="[`prize${prizeIdx}`]">
                  <div class="prizeItem" v-for="(item, i) in d.media" :key="i">
                    <div class="catImg hasImg" v-if="item"
                      :style="{'background-image': `url(${item.imageMd})`}">
                      <div class="more" v-on:click.stop="showPrizeMore = i"></div>
                      <div class="moreMenu" v-if="showPrizeMore === i"
                        v-on:click.stop="doNothing">
                        <li v-on:click.stop="editPrize(i, item)">Change Image</li>
                        <li class="red" v-on:click.stop="deletePrize(i, item)">Delete Image</li>
                      </div>
                    </div>
                    <div class="catImg" v-else>
                      <div class="more" v-on:click.stop="showPrizeMore = i"></div>
                      <div class="moreMenu" v-if="showPrizeMore === i"
                        v-on:click.stop="doNothing">
                        <li v-on:click.stop="editPrize(i, item)">Change Image</li>
                        <li class="red" v-on:click.stop="deletePrize(i, item)">Delete Image</li>
                      </div>
                    </div>
                  </div>
                  <div class="catImg addPrize" v-on:click="addPrize">
                    <span><img src="../assets/photo-black.png"></span>
                    Add Image
                  </div>
                </div>
              </div>
            </div>
          </div>
          <form v-on:submit.prevent="handleSubmit">
            <div class="fieldGroup">
              <div class="fieldCnt" :class="{hasError: form.name.error}">
                <label>Gallery Title</label>
                <input type="text" class="field" placeholder="Title..."
                  v-model="form.name.model" v-on:input="fieldChanged('name')">
                <div class="fieldError">Please input gallery title</div>
              </div>
            </div>
            <div class="fieldGroup">
              <label>Description</label>
              <textarea placeholder="Description..."
                class="field" rows="2" v-model="form.description.model"/>
            </div>
          </form>
        </div>
        <div class="modalAction">
          <button class="btn btnSecondary" type="button"
            v-on:click="close(false)" v-if="!btnLoading">
            <span>Cancel</span>
          </button>
          <button class="btn btnPrimary" type="submit" v-on:click="handleSubmit"
            :class="{disabled: d.media.length < 1,
            btnLoading: btnLoading}">
            <span>Save Gallery</span>
          </button>
        </div>
      </div>
      <Confirmation ref="confirmDialog"/>
      <MediaSelector ref="mediaSelector"/>
      <Snackbar ref="snackbar"/>
    </div>
  </transition>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';
import MediaSelector from '@/components/MediaSelector.vue';
import Snackbar from '@/components/Snackbar.vue';

export default {
  name: 'addUndian',
  components: {
    Confirmation,
    MediaSelector,
    Snackbar,
  },
  data() {
    return {
      show: false,
      loading: false,
      next: null,
      btnLoading: false,
      parentId: null,
      d: null,
      prizeIdx: 0,
      showPrizeMore: false,

      /**
       * Form
       *
       */
      form: {
        name: { model: '', error: null },
        description: { model: '', error: null },
      },
    };
  },
  methods: {
    open(parentId, d, n) {
      this.d = d;
      this.parentId = parentId;
      this.form.name.model = (d.title) ? d.title : '';
      this.form.name.error = null;
      this.form.description.model = (d.description) ? d.description : '';
      this.btnLoading = false;
      this.next = n;
      this.show = true;
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    deletePrize(i, item) {
      this.showPrizeMore = null;
      this.$refs.confirmDialog.open({
        title: 'Delete Image',
        desc: 'Are you sure you want to delete this image from gallery?',
      }, (b) => {
        if (!b) return;
        this.d.media.splice(i, 1);
      });
    },
    editPrize(i, item) {
      this.showPrizeMore = null;
      this.$refs.mediaSelector.open({ type: 'image' }, (b, media) => {
        if (!b) return;
        this.d.media[i].id = media.id;
        this.d.media[i].imageBl = media.imageBl;
        this.d.media[i].imageTh = media.imageTh;
        this.d.media[i].imageSm = media.imageSm;
        this.d.media[i].imageMd = media.imageMd;
        this.d.media[i].imageLg = media.imageLg;
      });
    },
    addPrize() {
      this.$refs.mediaSelector.open({ type: 'image' }, (b, media) => {
        if (!b) return;
        this.d.media.push(media);
      });
    },
    handleSubmit() {
      if (this.d.media.length < 1) return;
      const formData = {
        title: this.form.name.model,
        status: 'published',
        description: this.form.description.model,
        parentId: this.parentId,
        media: this.d.media,
        type: 'gallery',
      };
      if (this.d && this.d.id) formData.id = this.d.id;
      if (!formData.title) {
        this.form.name.error = true;
        return;
      }
      this.btnLoading = true;
      this.$http.post(this.$config.uri('article/save'), formData).then((r) => {
        this.btnLoading = false;
        if (r.data.status !== 200) {
          this.form.code.error = r.data.message;
          return;
        }
        this.close(true);
      });
    },
    fieldChanged(field) {
      this.form[field].error = null;
    },
  },
};
</script>

<style scoped lang="scss">
.tabCnt{
  margin: -16px 0 16px;
  .tab{
    width: 50%;
    background-color: #fff;
    padding: 10px 0;
    padding-left: 26px;
    &:before{
      left: 0; top: 13px;
      background-image: url(../assets/upload-black.png);
    }
    &.old{
      &:before{
        background-image: url(../assets/history.png);
      }
    }
  }
}
.fieldGroup.fg3{
  display: flex;
  .fieldCnt{
    width: 37%;
    margin-right: auto;
    &.radio{
      width: 120px;
      margin-right: 0;
    }
    .field.readonly{
      background-color: #eee;
      border-color: #ccc;
      cursor: default;
      box-shadow: none;
      outline: none;
    }
    .radioCnt{
      padding-top: 30px;
      .radioItem{
        position: relative;
        padding: 3px 0 0 60px;
        cursor: pointer;
        font-size: 18px;
        color: #767676;
        font-weight: 600;
        .radioIn{
          position: absolute;
          left: 0; top: 0;
          width: 50px; height: 30px;
          background-color: #ccc;
          border-radius: 50px;
          transition: all .2s ease;
          .radioHandle{
            background-color: #fff;
            position: absolute;
            left: 4px; top: 4px;
            transition: all .2s ease;
            width: 22px; height: 22px;
            border-radius: 50%;
          }
        }
        &.on{
          .radioIn{
            background-color: #0067ff;
            .radioHandle{
              left: 23px;
            }
          }
        }
      }
    }
  }
}
.modal{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  .modalOverlay{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(0,0,0,.7);
    // backdrop-filter: saturate(180%) blur(20px);
    z-index: 1;
    opacity: 1;
  }
  .modalContent{
    position: absolute;
    background-color: #fff;
    z-index: 2;
    padding: 30px 80px;
    border-radius: 5px;
    margin-top: -20px;
    overflow: hidden;
    max-width: none;
    width: 600px;
    .loading{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      background-color: rgba(255,255,255,.7);
      backdrop-filter: saturate(180%) blur(20px);
      background-image: url(../assets/loading.svg);
      background-position: center;
      background-size: 70px auto;
      background-repeat: no-repeat;
      z-index: 9;
    }
    .parent{
      box-shadow: 2px 2px 4px rgba(0,0,0,.2);
      border-radius: 5px;
      padding: 10px 16px;
      margin-bottom: 24px;
      h4{
        font-size: 14px;
        text-transform: uppercase;
        margin: 0;
        font-weight: 600;
        color: #999;
      }
      h5{
        margin: 0;
        margin-top: -2px;
        text-align: left;
        font-size: 20px;
        color: #555;
      }
    }
    .searchPeserta{
      margin: -16px 0 0;
      border-bottom: #eee 1px solid;
      padding: 10px 0;
      position: relative;
      &:before{
        position: absolute;
        z-index: 3;
        content: "";
        right: 16px; top: 20px;
        width: 16px; height: 16px;
        background-image: url(../assets/search.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .5;
      }
      &.searching{
        &:before{
          background-image: url(../assets/loading-2.svg);
        }
      }
      .field{
        border-radius: 50px;
        padding: 8px 16px;
      }
    }
    .pesertaCnt{
      height: 480px;
      overflow-y: auto;
      margin: 0 0 -30px;
      padding: 10px 0 20px;
      box-sizing: border-box;
      &.loadingPeserta{
        background-image: url(../assets/loading-2.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 46px auto;
      }
      .pesertaItem{
        padding: 6px 0;
        padding-right: 60px;;
        position: relative;
        &.loadMore{
          color: #0e5dd2;
          padding: 10px 0;
          cursor: pointer;
          display: inline-block;
          padding-left: 24px;
          &:before{
            position: absolute;
            content: "";
            left: 0; top: 12px;
            width: 16px; height: 16px;
            background-image: url(../assets/down-arrow-blue.png);
            background-position: center;
            background-size: 16px auto;
            background-repeat: no-repeat;
          }
          &.loadingMore{
            &:before{
              background-image: url(../assets/loading.svg);
            }
          }
        }
        .delete{
          position: absolute;
          right: 10px; top: 50%;
          transform: translateY(-50%);
          color: #0e5dd2;
          font-size: 15px;
          cursor: pointer;
          &:hover{
            color: #0747a6;
          }
        }
        h4{
          margin: 0 0 2px;
          font-size: 18px;
        }
        p{
          margin: 0;
          .bull{
            margin: 0 10px;
          }
        }
      }
    }
    .formCnt{
      .priceOk{
        position: relative;
        margin-top: -8px;
        .priceNav{
          position: absolute;
          top: 52px; width: 34px; height: 34px;
          border-radius: 50%;
          background-color: #fff;
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
          z-index: 9;
          cursor: pointer;
          transition: all .3s ease;
          &:hover{
            box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
          }
          &.n{
            right: -17px;
            background-image: url(../assets/right-arrow.png);
          }
          &.p{
            background-image: url(../assets/left-arrow.png);
            left: -17px;
          }
        }
        .priceSc{
          overflow: hidden;
          padding-top: 10px;
          position: relative;
        }
      }
      .prizeCnt{
        display: flex;
        transition: all .3s ease;
        &.prize1{ margin-left: -130px; }
        &.prize2{ margin-left: calc(-130px * 2); }
        &.prize3{ margin-left: calc(-130px * 3); }
        &.prize4{ margin-left: calc(-130px * 4); }
        &.prize5{ margin-left: calc(-130px * 5); }
        &.prize6{ margin-left: calc(-130px * 6); }
        &.prize7{ margin-left: calc(-130px * 7); }
        &.prize8{ margin-left: calc(-130px * 8); }
        &.prize9{ margin-left: calc(-130px * 9); }
        &.prize10{ margin-left: calc(-130px * 10); }
        &.prize11{ margin-left: calc(-130px * 11); }
        &.prize12{ margin-left: calc(-130px * 12); }
        &.prize13{ margin-left: calc(-130px * 13); }
        &.prize14{ margin-left: calc(-130px * 14); }
        &.prize15{ margin-left: calc(-130px * 15); }
        &.prize16{ margin-left: calc(-130px * 16); }
        &.prize17{ margin-left: calc(-130px * 17); }
        &.prize18{ margin-left: calc(-130px * 18); }
        &.prize19{ margin-left: calc(-130px * 19); }
        &.prize20{ margin-left: calc(-130px * 20); }
        &.prize21{ margin-left: calc(-130px * 21); }
        &.prize22{ margin-left: calc(-130px * 22); }
        &.prize23{ margin-left: calc(-130px * 23); }
        &.prize24{ margin-left: calc(-130px * 24); }
        &.prize25{ margin-left: calc(-130px * 25); }
        &.prize26{ margin-left: calc(-130px * 26); }
        &.prize27{ margin-left: calc(-130px * 27); }
        &.prize28{ margin-left: calc(-130px * 28); }
        &.prize29{ margin-left: calc(-130px * 29); }
        &.prize30{ margin-left: calc(-130px * 30); }
        .prizeItem{
          margin: 0 10px 10px 0;
          h4{
            margin: 5px 0 0;
            font-size: 14px;
            text-align: center;
            font-weight: 600;
          }
          p{
            text-align: center;
            margin: 0;
            font-size: 10px;
            color: #767676;
          }
        }
      }
      .catImg{
        width: 120px; height: 120px;
        background-color: #eee;
        border-radius: 5px;
        margin-right: auto;
        position: relative;
        transition: background-color, box-shadow .3s ease;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        box-sizing: border-box;
        &:before{
          content: "";
          position: absolute;
          left: 0; top: 0; right: 0; bottom: 0;
          opacity: .3;
          background-image: url(../assets/image-black.png);
          background-size: 46px auto;
          background-position: center;
          background-repeat: no-repeat;
          transition: all .3s ease;
        }
        .moreMenu{
          position: absolute;
          background-color: #fff;
          padding: 10px 0;
          box-shadow: 2px 2px 4px rgba(0,0,0,.2);
          border-radius: 3px;
          right: 6px; top: 6px;
          li{
            list-style: none;
            padding: 4px 16px;
            font-size: 15px;
            white-space: nowrap;
            transition: all .3s ease;
            cursor: pointer;
            &.red{
              color: red;
            }
            &:hover{
              background-color: #f5f5fe;
            }
          }
        }
        .more{
          background-color: #fff;
          width: 30px; height: 30px;
          position: absolute;
          right: -5px; top: -4px;
          border-radius: 50%;
          background-image: url(../assets/more.png);
          background-repeat: no-repeat;
          background-size: 12px auto;
          background-position: center;
          transition: opacity .3s ease;
          transition: all .3s ease;
          cursor: pointer;
          box-shadow: 2px 2px 4px rgba(0,0,0,.1);
          &:hover{
            opacity: 1;
            box-shadow: 2px 2px 6px rgba(0,0,0,.2);
          }
        }
        &.hasImg{
          &:before{
            display: none;
          }
        }
        &:hover{
          background-color: #e5e5e5;
          // box-shadow: 2px 2px 4px rgba(0,0,0,.2);
          &:before{
            opacity: .4;
          }
        }
        &.addPrize{
          font-size: 13px;
          font-weight: 600;
          color: #999;
          text-align: center;
          padding: 24px 0 0;
          text-transform: uppercase;
          cursor: pointer;
          span{
            display: block;
            font-size: 36px;
            font-weight: 400;
            margin: 0 0 -4px;
            img{
              height: 30px;
              opacity: .3;
            }
          }
          &:before{
            display: none;
          }
        }
      }
    }
    h4{
      margin: 0;
      font-size: 24px;
      font-weight: normal;
      margin-bottom: 20px;
      color: #444;
      text-align: left;
    }
    p{
      margin: 0;
      color: #767676;
    }
    .modalAction{
      margin: 30px -80px -30px;
      padding: 12px 30px;
      text-align: right;
      // background-color: #eee;
      border-top: #eee 1px solid;
      position: relative;
      .btn{
        margin-left: 10px;
      }
    }
  }
}

.imported{
  position: absolute;
  bottom: 0; right: 0; left: 0; top: 0;
  z-index: 991;
  text-align: center;
  background-color: #f5f5f5;
  padding: 40px 60px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  .importedIn{
    width: 100%;
    max-width: 460px;
    img{
      height: 86px;
      margin: 0 0 10px;
    }
  }
  h6{
    margin: 0 0 4px;
    font-size: 24px;
    font-weight: normal;
    text-align: center;
  }
  p{
    line-height: 1.4;
  }
  .btn{
    margin: 16px 0 -20px !important;
    &.btnPrimary{
      margin-left: 10px !important;
    }
  }
}
.errorLabel{
  color: red;
  font-size: 13px;
  margin: 5px 0 0 5px;
}
.dragArea{
  padding: 40px 0;
  text-align: center;
  border: #ccc 4px dashed;
  position: relative;
  &.hasError{
    border-color: red;
  }
  .uploadPorgress{
    position: absolute;
    left: -4px; top: -4px; right: -4px; bottom: -4px;
    z-index: 1;
    border-radius: 5px;
    background-color: #eee;
    display: flex;
    justify-content: center;
    align-items: center;
    display: none;
    .progressLabel{
      font-size: 15px;
      color: #767676;
    }
    .progressBar{
      background-color: #ddd;
      height: 12px;
      width: 200px;
      margin-top: 10px;
      border-radius: 50px;
      .pbin{
        height: 100%;
        background-color: #ed1d51;
        background-image: linear-gradient(45deg, #ed1d51, #ffc875);
        border-radius: 50px;
        transition: width .3s linear;
      }
    }
  }
  &.uploading{
    border-color: #fff;
    .uploadPorgress{
      display: flex;
    }
  }
  &.dragover{
    border-color: #0057d8;
  }
  p{
    margin: 0;
    font-size: 17px;
    color: #444;
  }
  span{
    display: block;
    color: #767676;
    margin: 4px 0 6px;
  }
  button{
    border-radius: 3px;
    color: #fff;
    border: none;
    box-shadow: none;
    font-size: 16px;
    background-color: #0057d8;
    padding: 8px 16px;
    outline: 0;
    cursor: pointer;
    &:hover{
      background-color: #0067ff;
    }
  }
}

.help{
  margin-top: 20px;
  color: #767676;
  font-size: 15px;
  a{
    display: inline-block;
    padding: 5px 14px;
    margin: 6px 0 10px;
    border-radius: 50px;
    font-size: 15px;
    border: #ddd 1px solid;
    padding-left: 36px;
    position: relative;
    color: #444;
    cursor: pointer;
    &:hover{
      background-color: #eee;
    }
    &:before{
      content: "";
      position: absolute;
      left: 14px; top: 0; bottom: 0;
      width: 14px;
      background-image: url(../assets/download-o.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  img{
    width: 100%;
    height: auto;
    border: #eee 1px solid;
    box-sizing: border-box;
  }
}

</style>
